import React, { useEffect, useRef, useState } from "react";
import Layout from "../Common/Layout";
import axios from "axios";
import { useParams } from "react-router-dom";

const CRDPrint = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth < 768);

    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const { crdNo } = useParams();
  const token = sessionStorage.getItem("token");

  const formRef = useRef();

  const [formdata, setFormData] = useState({});
  const [trucks, setTrucks] = useState([]);

  // ======================
  // FETCH CRD
  // ======================

  const fetchCRD = async () => {
    try {
      const res = await axios.get(
        `https://irc.zentelex.com/api/commodity-receipts/commodity-receipt/crd/${crdNo}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const list = res.data.data;

      if (!list || list.length === 0) return;

      // HEADER DATA FROM FIRST ROW
      const data = list[0];

      setFormData({
        crdNo: data.crdNo,
        Date: data.receiptDate,
        WarehouseName: data.warehouseName,
        WarehouseAddress: data.warehouseAddress,
        LocationName: data.locationName,
        ClientName: data.clientName,
        ClientAddress: data.clientAddress,
        NameofCommodity: data.commodityName,
        Variety: data.variety,
        NoofBags: data.noOfBags,
        Quantity: data.quantityMT,
        Stack: data.stackNo,
        Rate: data.ratePerMT,
        PackingQuality: data.packingQuality,
        PrivateID: data.privateIdMark,
        Remarks: data.remarks,
      });

      // 🔥 MERGE ALL TRUCK DETAILS
      const allTrucks = list.flatMap((item) => item.truckDetails || []);

      setTrucks(allTrucks);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCRD();
  }, []);

  // ======================
  // PRINT
  // ======================
  const handlePrint = () => {
    const printContents = formRef.current.innerHTML;

    const win = window.open("", "_blank");

    win.document.write(`
      <html>
      <head>
        <title>CRD Print</title>

        <style>
          body{
            font-family: Arial;
            padding:20px;
          }

          h1,h2,h3,h4{
            text-align:center;
            margin:4px;
          }

          table{
            width:100%;
            border-collapse:collapse;
            margin-top:10px;
          }

          td,th{
            border:1px solid black;
            padding:6px;
            font-size:14px;
          }

          .section-title{
            font-weight:bold;
            margin-top:15px;
            font-size:18px;
          }

          @media print {
            button{ display:none; }
          }
        </style>

      </head>

      <body>
        ${printContents}
      </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed", // ⭐ IMPORTANT
  };

  const thStyle = {
    border: "1px solid black",
    padding: isMobile ? "6px" : "10px",
    fontSize: isMobile ? "12px" : "14px",
    textAlign: "left",
    background: "#f5f5f5",
    width: "25%",
  };

  const tdStyle = {
    border: "1px solid black",
    padding: isMobile ? "6px" : "10px",
    fontSize: isMobile ? "12px" : "14px",
    height: "38px", // ⭐ Equal height
    wordBreak: "break-word",
  };

  return (
    <Layout>
      <div className="container mt-4">
        {/* ================= PRINT AREA ================= */}
        <div
          ref={formRef}
          style={{
            padding: isMobile ? "10px" : "20px",
            overflowX: "auto",
            background: "#fff",
          }}
        >
          {/* HEADER */}
          <h2
            style={{
              textAlign: "center",
              fontSize: isMobile ? "20px" : "28px",
              fontWeight: "bold",
            }}
          >
            IRC LIMITED
          </h2>

          <p className="center">
            IRC HOUSE, 1 SUNYAT SEN STREET , KOLKATA-700012 <br />
            TELEPHONE NO.: +91-33-2236-5110 (5 Lines) FAX: +91-33-2225 5936{" "}
            <br />
            Email : ho@ircl.in
          </p>

          <h3 className="doc-title">COMMODITY RECEIPT DOCUMENT</h3>

          {/* CRD NO */}
          <table style={tableStyle}>
            <tbody>
              <tr>
                <th style={thStyle}>CRD No.</th>
                <td style={tdStyle}>{formdata.crdNo}</td>

                <th style={thStyle}>Date</th>
                <td style={tdStyle}>{formdata.Date}</td>
              </tr>
            </tbody>
          </table>

          {/* WAREHOUSE */}
          <h4
            style={{
              marginTop: "15px",
              fontSize: isMobile ? "14px" : "18px",
              fontWeight: "bold",
            }}
          >
            Warehouse Details
          </h4>

          <table style={tableStyle}>
            <tbody>
              <tr>
                <th style={thStyle}>Warehouse Name</th>
                <td style={tdStyle}>{formdata.WarehouseName}</td>
              </tr>

              <tr>
                <th style={thStyle}>Warehouse Address</th>
                <td style={tdStyle}>{formdata.WarehouseAddress}</td>
              </tr>
            </tbody>
          </table>

          {/* CLIENT */}
          <h4 className="section">Client Details</h4>

          <table style={tableStyle}>
            <tbody>
              <tr>
                <th style={thStyle}>Client Name</th>
                <td style={tdStyle}>{formdata.ClientName}</td>

                <th style={thStyle}>Client Address</th>
                <td style={tdStyle}>{formdata.ClientAddress}</td>
              </tr>

              <tr>
                <th style={thStyle}>Commodity</th>
                <td style={tdStyle}>{formdata.NameofCommodity}</td>

                <th style={thStyle}>Variety</th>
                <td style={tdStyle}>{formdata.Variety}</td>
              </tr>
            </tbody>
          </table>

          <br />

          {/* COMMODITY GRID */}
          <div
            style={{
              width: "100%",
              overflowX: isMobile ? "auto" : "visible",
            }}
          >
            <table
              style={{
                width: "100%",
                minWidth: "900px", // IMPORTANT for mobile scroll
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  {[
                    "CRD No",
                    "No. of Bags",
                    "Quantity (MT)",
                    "Stack No.",
                    "Rate/MT",
                    "Packing Quality",
                    "Private ID / Mark of Depositor",
                    "Remarks",
                  ].map((head, i) => (
                    <th
                      key={i}
                      style={{
                        border: "1px solid black",
                        padding: isMobile ? "6px" : "10px",
                        fontSize: isMobile ? "11px" : "14px",
                        background: "#f3f3f3",
                        whiteSpace: "nowrap",
                        textAlign: "center",
                      }}
                    >
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                <tr>
                  {[
                    formdata.crdNo,
                    formdata.NoofBags,
                    formdata.Quantity,
                    formdata.Stack,
                    formdata.Rate,
                    formdata.PackingQuality,
                    formdata.PrivateID,
                    formdata.Remarks,
                  ].map((val, i) => (
                    <td
                      key={i}
                      style={{
                        border: "1px solid black",
                        padding: isMobile ? "6px" : "10px",
                        fontSize: isMobile ? "11px" : "14px",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {val}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>

          {/* TRUCK */}
          <h4 className="section">Truck Wise Net Weight</h4>

          <div
  style={{
    width: "100%",
    overflowX: "hidden", // ❌ remove scroll
  }}
>
  <table
    style={{
      width: "100%",
      borderCollapse: "collapse",
      tableLayout: "fixed", // equal columns
    }}
  >
    <thead>
      <tr>
        {["#", "Truck No", "Net Weight", "No Of Bags"].map(
          (head, i) => (
            <th
              key={i}
              style={{
                width: "25%",
                border: "1px solid black",
                padding: isMobile ? "6px" : "10px",
                textAlign: "center",
                background: "#f3f3f3",
                fontSize: isMobile ? "11px" : "14px",
                wordBreak: "break-word", // ✅ wrap text
              }}
            >
              {head}
            </th>
          )
        )}
      </tr>
    </thead>

    <tbody>
      {trucks.map((t, i) => (
        <tr key={i}>
          {[i + 1, t.truckNo, t.netWeight, t.noOfBags].map(
            (val, idx) => (
              <td
                key={idx}
                style={{
                  width: "25%",
                  border: "1px solid black",
                  padding: isMobile ? "6px" : "10px",
                  textAlign: "center",
                  fontSize: isMobile ? "11px" : "14px",
                  wordBreak: "break-word", // ✅ prevents overflow
                }}
              >
                {val}
              </td>
            )
          )}
        </tr>
      ))}
    </tbody>
  </table>
</div>
        </div>

        {/* PRINT BUTTON */}
        <div className="text-center mt-4">
          <button
            className="btn btn-primary"
            style={{
              width: isMobile ? "100%" : "auto",
              fontSize: isMobile ? "14px" : "16px",
            }}
            onClick={handlePrint}
          >
            Print CRD Form
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default CRDPrint;
